import { es, en, pt } from './langs';

const locales = { es, en, pt };

export default locales;
